module.exports = __webpack_public_path__ + "static/img/logo_bprc.a8593b91.png";